import { IonIcon, IonInput, IonItem } from '@ionic/react';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

import { mailOutline } from 'ionicons/icons';

import { useAuthActions } from '../../../hooks/Auth/useAuth';
import { useAlert } from '../../../hooks/UI/useAlert';
import { useEnter } from '../../../hooks/Utils/useEnter';
import {
  PasswordReq,
  Password as PasswordType,
  passwordDefaults,
} from '../../../types/Auth/types';
import { validations } from '../../../utils/validations';
import Alert from '../../UI/Alert';
import Button from '../../UI/Button';
import FormItem from '../../UI/FormItem';
import Spinner from '../../UI/Spinner';
import './Password.scss';
import { PasswordRecoverProps } from './types';

const Password: React.FC<PasswordRecoverProps> = ({ setAuthMode }) => {
  const { password } = useAuthActions();
  const { ref, handleEnter } = useEnter();
  const { control, handleSubmit, errors } = useForm<PasswordType>({
    defaultValues: passwordDefaults,
  });
  const { alertState, showAlert, hideAlert } = useAlert();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onSubmit = async (values: PasswordReq) => {
    setIsLoading(true);
    try {
      const body = {
        email: values.email.trim(),
      };

      const { success, error } = await password(body);

      if (success) {
        showAlert({
          header: '¡Éxito!',
          message: 'Se envió un correo de recuperación',
          buttons: [{ text: 'Entendido', handler: () => setAuthMode('login') }],
        });
      } else {
        showAlert({
          header: 'Error',
          message: error!,
          buttons: [{ text: 'Entendido', role: 'cancel' }],
        });
      }
    } catch (error) {
      console.error(error);
      showAlert({
        header: 'Error',
        message: 'Ocurrió un error inesperado, intenta nuevamente',
        buttons: [{ text: 'Entendido', role: 'cancel' }],
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} onKeyUp={(e) => handleEnter(e)}>
      <FormItem
        errors={errors}
        control={control}
        name="email"
        rules={{
          required: 'Por favor, ingresá tu email',
          pattern: validations.email,
        }}
        render={({ onChange }) => (
          <IonItem>
            <IonInput type="email" placeholder="Email" onIonChange={onChange}>
              <IonIcon icon={mailOutline} />
            </IonInput>
          </IonItem>
        )}
      />

      <div className="ion-margin-top mt-aux">
        <Button ref={ref} type="submit" disabled={isLoading}>
          {!isLoading ? 'Enviar' : <Spinner color="light" />}
        </Button>
      </div>

      <Alert
        isOpen={alertState.isOpen}
        header={alertState.header}
        message={alertState.message}
        buttons={alertState.buttons}
        onDidDismiss={hideAlert}
      />
    </form>
  );
};

export default Password;
